import React from 'react';

import SesamLink from '../common/Links/SesamLink';
import { ConnectionString } from './ConnectionString.view';

import './ConnectMessages.scss';

import './ConnectMessages.scss';

export const IdMismatchMessage: React.FC<{
  subId: string;
  lastUrl: string;
}> = ({ subId, lastUrl }) => (
  <>
    <h2 className="connect-message-title">Url belongs to another subscription</h2>
    <p>
      The subscription at <ConnectionString url={lastUrl} /> belongs to another subscription.
    </p>
    <p>
      If you have access to this subscription, you can transfer the license for this subscription to
      this url.
    </p>
    <p>
      Make sure you don't breach the license agreement by using the same license on multiple
      instances.
    </p>
    <p>
      Goto{' '}
      <SesamLink to={`/subscription/${subId}/settings-subscription/license`}>
        license settings
      </SesamLink>{' '}
      to fix license.
    </p>
  </>
);
